export const FETCH_ACTIVATIONS = 'FETCH_ACTIVATIONS'
export const FETCH_ACTIVATIONS_SENT = 'FETCH_ACTIVATIONS_SENT'
export const FETCH_ACTIVATIONS_SUCCESS = 'FETCH_ACTIVATIONS_SUCCESS'
export const FETCH_ACTIVATIONS_FAILED = 'FETCH_ACTIVATIONS_FAILED'
export const PORTAL_ACTIVATE_MANUALLY_SUCCESS = 'Portal/ActivateManuallySuccess'
